import { Module } from 'vuex';
import { DocsState } from '@/store';

export interface DrawerInfo {
  drawer: Object;
  wide: boolean;
  data: any;
}

export interface DrawerStore {
  drawer: DrawerInfo | null;
  wide: boolean;
}

export enum DrawerMutations {
  OpenDrawer = 'ds/OpenDrawer',
  CloseDrawer = 'ds/CloseDrawer',
}

export enum DrawerActions {
  CloseDrawer = 'ds/CloseDrawer',
}

const sn = (str: DrawerActions | DrawerMutations): string =>
  str.replace(/ds\//g, '');

const DRAWER_TRANSITION_TIME = 400;

export const drawerStore: Module<DrawerStore, DocsState> = {
  namespaced: true,
  state: {
    drawer: null,
    wide: false,
  },
  mutations: {
    [sn(DrawerMutations.OpenDrawer)](state, drawer: DrawerInfo) {
      state.drawer = drawer;
      state.wide = !!drawer.wide;
    },
    [sn(DrawerMutations.CloseDrawer)](state) {
      state.drawer = null;
      state.wide = false;
    },
  },
  actions: {
    async [sn(DrawerActions.CloseDrawer)]({ state, commit }) {
      if (state.drawer) {
        setTimeout(
          () => commit(sn(DrawerMutations.CloseDrawer)),
          DRAWER_TRANSITION_TIME,
        );
      }
    },
  },
};
